import { create } from 'zustand';
import { configureSound } from '../audio/sfx';

interface SettingsState {
  muted: boolean;
  volume: number;
  toggleMuted(): void;
  setVolume(value: number): void;
}

function load() {
  try {
    const value = JSON.parse(localStorage.getItem('cc:sound') ?? '{}') as { muted?: boolean; volume?: number };
    return { muted: value.muted ?? false, volume: value.volume ?? 0.7 };
  } catch { return { muted: false, volume: 0.7 }; }
}

const initial = typeof localStorage === 'undefined' ? { muted: false, volume: 0.7 } : load();
configureSound(initial);

export const useSettingsStore = create<SettingsState>((set, get) => ({
  ...initial,
  toggleMuted: () => {
    const next = { muted: !get().muted, volume: get().volume };
    configureSound(next);
    localStorage.setItem('cc:sound', JSON.stringify(next));
    set({ muted: next.muted });
  },
  setVolume: (volume) => {
    const next = { muted: get().muted, volume };
    configureSound(next);
    localStorage.setItem('cc:sound', JSON.stringify(next));
    set({ volume });
  },
}));
